import Vue from 'vue';

import ChangePasswordView from '@/components/Login/ChangePassword.vue';
import ForgotPasswordView from '@/components/Login/ForgotPassword.vue';
import LogInView from '@/components/Login/LogIn.vue';
import NewPasswordView from '@/components/Login/NewPassword.vue';

Vue.component('change-view', ChangePasswordView);
Vue.component('forgot-view', ForgotPasswordView);
Vue.component('login-view', LogInView);
Vue.component('new-view', NewPasswordView);

export {
  ChangePasswordView,
  ForgotPasswordView,
  LogInView,
  NewPasswordView,
};
